import { Swiper } from "swiper";

const mySwiper = new Swiper(".swiper-for-mobile", {
  spaceBetween: 16,
  slidesPerView: "auto",
  watchOverflow: true,
  breakpoints: {
    640: {
      spaceBetween: 24,
    },
  },
});
